import { useEffect, useState } from "react";
import { getDashboardPath } from "../utils/authRedirect";
import { useIsMobile } from "./useMediaQuery";

export function useStandalone() {
  const [standalone, setStandalone] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(display-mode: standalone)");
    const check = () => {
      setStandalone(
        mq.matches ||
          window.navigator.standalone === true ||
          document.referrer.includes("android-app://"),
      );
    };
    check();
    mq.addEventListener("change", check);
    return () => mq.removeEventListener("change", check);
  }, []);

  return standalone;
}

export function useIsClientApp(isClient) {
  return Boolean(isClient);
}

export function useIsAdminApp(isAdmin) {
  return Boolean(isAdmin);
}

/** Splash only on mobile / installed PWA; skip in landing iframe embed */
export function useSkipPwaSplash() {
  const isMobile = useIsMobile(768);
  const standalone = useStandalone();
  if (typeof window !== "undefined") {
    try {
      if (new URLSearchParams(window.location.search).get("landing_embed") === "1") {
        return true;
      }
    } catch {
      /* ignore */
    }
  }
  return !isMobile && !standalone;
}

export function useShowPwaBanners() {
  const isMobile = useIsMobile(768);
  const standalone = useStandalone();
  return isMobile || standalone;
}

export function usePwaEntryRedirect(initialized, isAuth, role, pathname, navigate) {
  useEffect(() => {
    if (!initialized || !isAuth || !role) return;
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (!standalone) return;

    const dash = getDashboardPath(role).replace(/\/$/, "");
    const path = pathname.replace(/\/$/, "") || "/";
    const entries = new Set(["/", "/app", "/manage/app", "/staff/app"]);
    if (!entries.has(path) || path === dash) return;
    navigate(dash, { replace: true });
  }, [initialized, isAuth, role, pathname, navigate]);
}
